<template>
    <div>
        <div class="d-flex justify-content-start mb-3">
            <select id="hospital" name="institute_relations"class="form-control ms-2" style="max-width:60%" v-model="selectedInsituteId" placeholder="Επιλέξτε ίδρυμα ιστών" @change="onChangeHospital">
                <option value="0" selected>Επιλέξτε Μονάδα εφαρμογής</option>
                <option v-for="institute in institutions" :key="institute.id" :value="institute.id">{{ institute.title }}</option>
            </select>
            <button class="btn ms-2" @click="resetInstitute">
                <img src="../assets/images/asterisk16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px"> Προβολή όλων...
            </button>
            <div v-if="selectedHospitalAfm" class="ms-3 mt-1">
                <p>ΑΦΜ επιλογής: <b>{{ selectedHospitalAfm }}</b></p>
            </div>
        </div>
        <!-- Tabs Content -->
        <div class="d-flex">
                
                <!-- Main Content Area -->
                <div class="content-area" :class="{ 'shrink': hospitalShown, 'expand': !hospitalShown }">
                    <div>
                <div class="d-flex">
                    <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                    Αναζήτηση με:
                </label>
                <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                    <option value="" selected>Επιλέξτε...</option>
                        <option value="implant_name_mm">Μόσχευμα</option>
                        <option value="category">Κατηγορία</option>    
                        <option value="institution_name">Ίδρυμα ιστών</option>   
                        <option value="sec">Κωδικός SEC</option>                                                     
                        <option value="patient_amka">ΑΜΚΑ Ασθενούς</option>     
                    </select>
                    <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Κριτήριο..." />
                    <button class="btn ms-2" @click="handleExport()">
                    <img src="../assets/images/excel16.png" alt="Excel" class="menu-img" style="width:1.1em; margin-right:10px">
                    MS-Excel
                </button>
                </div>

                <table class="table table-bordered table-hover table-striped">
                    <tr style="border-bottom: 2px solid gray; "><td></td><td style="padding-left:15px">Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td></tr>

                    <thead class="table-light">
                        <tr>
                            <th @click="sortTable('id')">
                                A/A
                                <span v-if="sortKey === 'id'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('implant_name_mm')">
                                Προϊον EUTC
                                <span v-if="sortKey === 'implant_name_mm'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('category')">
                                Κατηγορια
                                <span v-if="sortKey === 'category'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('sec')">
                                Κωδικος SEC
                                <span v-if="sortKey === 'sec'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('apply_date')">
                                Ημ/νια Εφαρμογης
                                <span v-if="sortKey === 'apply_date'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('patient_amka')">
                                ΑΜΚΑ Ασθενους
                                <span v-if="sortKey === 'patient_amka'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('institution_name')">
                                Ιδρυμα Ιστων
                                <span v-if="sortKey === 'institution_name'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('hospital_name')">
                                ΜΟΝΑΔΑ ΕΦΑΡΜΟΓΗΣ
                                <span v-if="sortKey === 'hospital_name'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="hospital in hospitals" :key="hospital.id" @click="showHospital(hospital)" :class="{ active2: selectedRow?.id === hospital.id }">
                            <td><img src="../assets/images/implant16.png" alt="Citrine Logo" 
                                class="menu-img" style="width:1.1em; margin-right:5px">{{ hospital.id }}</td>
                            <td>{{ hospital.implant_name_mm }}</td>
                            <td>{{ hospital.category }}</td>
                            <td :title="hospital.sec">{{ limitSec(hospital.sec) }}</td>
                            <td>{{ formatLicenseExp(hospital.apply_date) }}</td>
                            <td>{{ hospital.patient_amka }}</td>
                            <td>{{ hospital.institution_name }}</td>
                            <td>{{ hospital.hospital_name }}</td>
                        </tr>
                    </tbody>
                </table>
                <nav aria-label="Page navigation">
                    <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                        <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                            :key="index" :class="{ active: paginationLink.active }">
                            <router-link
                                :to="{ path: 'hospitals', query: { page: getPageFromUrl(paginationLink.url) } }"
                                v-if="paginationLink.url">
                                <span class="page-link" v-html="paginationLink.label"></span>
                            </router-link>
                            <span class="page-link" v-else v-html="paginationLink.label"></span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>            <!-- Implant Details -->
            <div class="implant_details" v-if="hospitalShown">
                <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
            <label class="fw-bolder mb-0 me-2" style="font-size: medium; white-space: nowrap;">
                Στοιχεία Εφαρμοσμένου Μοσχεύματος
            </label>
            <div class="d-flex ms-auto">
               
                <button class="btn" @click="closeDetails">
                    <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                </button>
            </div>
        </div>
                <h5 class="mb-4">{{ selectedHospital.implant_name_mm }}</h5>
                <div class="implant-details-container">
                    <div class="implant-detail shadow mb-2">
                <strong class="label-text">Α/Α</strong>
                <div class="value-text">{{ selectedHospital.id }}</div>
            </div>

                    <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κατηγορία</strong>
                <div class="value-text">{{ selectedHospital.category }}</div>
            </div>

            <div class="implant-detail shadow mb-2">
                <strong class="label-text">ΑΜΚΑ Ασθενούς</strong>
                <div class="value-text">{{ selectedHospital.patient_amka }}</div>
            </div>

            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Ημ/νία Εφαρμογής</strong>
                <div class="value-text">{{ formatLicenseExp(selectedHospital.apply_date) }}</div>
            </div>
            
            
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Κωδικός SEC</strong>
                <div class="value-text">{{ selectedHospital.sec }}</div>
            </div>

            <div class="implant-detail shadow mb-5">
                <strong class="label-text">Ίδρυμα Ιστών</strong>
                <div class="value-text">{{ selectedHospital.institution_name ? selectedHospital.institution_name : '-' }}</div>
            </div>
            
        </div>
        <span class="smallTitle mt-5">*Τελευταία τροποποίηση: {{ selectedHospital.updated_at_formatted ? selectedHospital.updated_at_formatted : '' }}</span>

            </div>
        </div>
    </div>
</template>


<script>
import { getInstitutions, postInstitute, deleteInstitutionById, deleteRelationsForInstitute, getInstalled, getNotUsed, getUsed, getExpired, downloadExportInstall, downloadExportNotUsed, downloadExportUsed, downloadExportExpired, downloadFile } from "../services/institutions";
import { deleteHospitalById, downloadExportHospitals, getHospitals, getHospitalsAll, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant } from "@/services/grafts";
import { useToast } from "vue-toastification";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";

export default {
    data() {
        return {
            totalCount: 0,
            selectedHospitalAfm: null,
            searchField: "",
            searchValue: "",
            institutions: [],
            installedImplants: [],
            notUsedImplants: [],
            usedImplants: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedHospital: null,
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            hospitalShown: false,
            selectedRow: null, 

        };
    },
    methods: {
        limitSec(sec) {
        if (sec && sec.length > 10) {
            return sec.substring(0, 10) + '...';
        }
        return sec;
    },
        download() {
            if (!this.selectedImplant.file_name) {
                useToast().error('Δεν υπάρχει αρχείο!');
            } else {
                downloadFile(this.selectedImplant.id, this.selectedImplant.file_name, this.selectedImplant.mime_type);
            }
        },
        closeDetails() {
            this.hospitalShown = false;
        },
        onChangeHospital() {
            let hospital = null;
            for (let i = 0; i < this.institutions.length; i++) {
                if (this.institutions[i].id == $("#hospital").val()) {
                    hospital = this.institutions[i];
                }
            }
            if (hospital) {
                this.selectedHospitalAfm = hospital.afm;
            } else {
                this.selectedHospitalAfm = null;
            }
        },
        showHospital(hospital) {
            this.selectedHospital = hospital;
            this.hospitalShown = true;
            this.selectedRow = hospital;
        },
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh();
        },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        resetInstitute() {
            this.selectedInsituteId = "0";
            this.selectedHospitalAfm = null;
            this.page = 1; // Reset to page 1
            // Update the URL with page = 1
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, page: 1 }
            });
            this.handleRefresh();
        },
        async handleRefresh() {
            let params = {
                    hospid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchField != "" && this.searchValue != "") {
                    params[this.searchField] = this.searchValue;
                }

            const hospitals = (await getHospitalsAll(params)).data.data;
            this.hospitals = hospitals.results.data;
            this.paginationLinks = hospitals.results.links;
            this.totalCount = hospitals.count;
        },
        handleExport() {
            let params = {
                    hospid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchField != "" && this.searchValue != "") {
                    params[this.searchField] = this.searchValue;
                }
            downloadExportHospitals(params);
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        }
    },
    async mounted() {
        const hospit = (await getHospitals()).data.data;
        this.institutions = hospit;
        const hospitals = (await getHospitalsAll()).data.data;
        this.hospitals = hospitals.results.data;
        this.paginationLinks = hospitals.results.links;
        this.totalCount = hospitals.count;
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                const page = newRoute.query.page || 1; // Default to page 1 if not in URL
                this.page = page;
                this.handleRefresh();
            }
        },
        selectedInsituteId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchField: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchValue: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        }
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
    width:100%;
}

.btn{
    background-color: #f6f6f6;
}

.btn:hover, .btn-md:hover{
    background-color: #ececec;
}
.btn-md{
    background-color: white;
    border:none;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%; /* Ensures the layout fits the screen height */
    overflow: hidden; /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1; /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0; /* Prevent the content from overflowing */
    padding-right: 10px; /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68; /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32; /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px; /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px); /* Default to full width */
    padding-left: 10px;
    font-size:medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d; /* Muted text for the label */
    margin-bottom: 5px;
    display: block; /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%; /* Ensure table stays within bounds */
    table-layout: fixed; /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word; /* Handle long text gracefully */
}

th, td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}


.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text, .value-text{
    font-size: small;
}

.active2 {
    background-color: #ffefbb; /* Light blue background */
    font-weight: bold; /* Make the text bold */
}

</style>